
/*
 * Copyright (c) 2015/7/23
 * Paweł Bednarek
 * http://ninjaweb.pl
 * pawel@bednarek.it
 */

var NinjaWeb = function() {
};

/**
 * Cały box linkuje
 * do wewnętrznego linka
 *
 * @param {Object} selectors
 */

NinjaWeb.prototype.clickWholeBox = function(selectors) {
    jQuery(selectors.box).click(function() {
        var _this = jQuery(this);

        jQuery(selectors.link, _this).one('click', function(e) {
            e.stopPropagation();
            window.location = jQuery(this).attr('href');

            return false;
        }).trigger('click');

    });
};

/**
 * Pokaz sub menu
 * Po najechaniu na podany element
 * funkcja dodaję klase do elementu
 *
 * @param {Object} selector
 */

NinjaWeb.prototype.showSubMenu = function(selector) {
    var activeLi;
    jQuery(selector.select).mouseover(function () {
        var _this = jQuery(this);

        activeLi = !!_this.hasClass('show-menu');
        _this.addClass('show-menu');
    }).mouseout(function () {
        var _this = jQuery(this);

        if (activeLi === false) _this.removeClass('show-menu');
    });
};


/**
 * Blokuje linki o podanym selektorze
 *
 * @param {Object} selector
 */

NinjaWeb.prototype.disableLink = function(selector) {
    jQuery(selector.select).click(function(event){
        event.preventDefault();
    });
};


/**
 * Odlicza czas od teraz do podanej daty
 *
 * @param {String} dt - string daty '09/27/2015 09:00 AM'
 * @param {String} id - DOM id np '#licznik'
 */

var CountDownTimer = function(dt, id, endtext){
    var end = new Date(dt);

    var _second = 1000;
    var _minute = _second * 60;
    var _hour = _minute * 60;
    var _day = _hour * 24;
    var timer;

    function showRemaining() {
        var now = new Date();
        var distance = end - now;
        if (distance < 0) {

            clearInterval(timer);
            document.getElementById(id).innerHTML = endtext;

            return;
        }
        var days = Math.floor(distance / _day);
        var hours = Math.floor((distance % _day) / _hour);
        var minutes = Math.floor((distance % _hour) / _minute);
        var seconds = Math.floor((distance % _minute) / _second);

        document.getElementById(id).innerHTML = days + ' dni ';
        document.getElementById(id).innerHTML += hours + ' godz ';
        document.getElementById(id).innerHTML += minutes + ' min ';
        document.getElementById(id).innerHTML += seconds + ' sek';
    }

    timer = setInterval(showRemaining, 1000);
};

var CountDownTimerENG = function(dt, id, endtext){
    var end = new Date(dt);

    var _second = 1000;
    var _minute = _second * 60;
    var _hour = _minute * 60;
    var _day = _hour * 24;
    var timer;

    function showRemaining() {
        var now = new Date();
        var distance = end - now;
        if (distance < 0) {

            clearInterval(timer);
            document.getElementById(id).innerHTML = endtext;

            return;
        }
        var days = Math.floor(distance / _day);
        var hours = Math.floor((distance % _day) / _hour);
        var minutes = Math.floor((distance % _hour) / _minute);
        var seconds = Math.floor((distance % _minute) / _second);

        document.getElementById(id).innerHTML = days + ' days ';
        document.getElementById(id).innerHTML += hours + ' h ';
        document.getElementById(id).innerHTML += minutes + ' min ';
        document.getElementById(id).innerHTML += seconds + ' sec';
    }

    timer = setInterval(showRemaining, 1000);
};
